import "./Suport.css";
import IconSuport from "../../../assets/images/icon-suport.svg";
import React, { useState } from "react";
import Select, { components } from "react-select";
import makeAnimated from "react-select/animated";
import Swal from "sweetalert2";
import Preloader from "../../shared/preloader/Preloader";
import { sendEmail } from "../../../services/support/support";

/**
 * MENSAJES PERSONALIZADOS AL BUSCAR O CARGAR OPCIONES EN REACT SELECT
 */

const { NoOptionsMessage } = components;

const customNoOptionsMessage = (props) => (
  <NoOptionsMessage {...props}>No registrado</NoOptionsMessage>
);

const { LoadingMessage } = components;

const customLoadingMessage = (props) => (
  <LoadingMessage {...props}>Cargando</LoadingMessage>
);

/**
 * ANIMATE DELETE MULTISELECT
 */

const animatedComponents = makeAnimated();

/**
 * Data que llena los select
 */

const CustomSelect = [
  { value: "opcion-uno", label: "Cienciometria" },
  { value: "opcion-dos", label: "" },
  { value: "opcion-tres", label: "Opcion tres" },
];

/**
 * Constante que soporta todo el cambio de los estilo del select
 */

const selectStyles = {
  /**
   * Estilos del icono del dropdown del select
   * Estilos del separador del select
   * Estilos del icono de cerrar del select
   */
  dropdownIndicator: (styles) => ({
    ...styles,
    color: "var(--color-white-)",
    padding: 0,
    paddingTop: "0rem !important",
    paddingRight: "0.5rem !important",
    "&:hover": {
      color: "var(--color-white-)",
    },
  }),
  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "var(--color-white-)",
    padding: 0,
    paddingTop: "0rem !important",
    "&:hover": {
      color: "var(--color-white-)",
    },
  }),
  /**
   * Estilos del input global
   */
  control: () => ({
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    alignSelf: "start",
    justifyContent: "start",
    height: "auto",
    minHeight: 50,
    maxHeight: 150,
    paddingLeft: "15px",
    paddingTop: "0.3rem",
    width: "100%",
    backgroundColor: "var(--color-quaternary-blue-)",
    borderRadius: "1.18rem",
    border: "0px solid transparent",
  }),
  /**
   * EESTILOS DEL INPUT
   */
  input: (provided) => ({
    ...provided,
    color: "var(--color-white-)",
    fontSize: 14,
    fontFamily: "var(--font-family-regular-)",
  }),
  /**
   * Estilos del menu desplegable del select
   */
  menu: (styles) => ({
    ...styles,
    border: "none",
    borderColor: "var(--color-quaternary)",
    backgroundColor: "var(--color-tertiary-white-rgba-)",
    boxShadow: "var(--box-shadow-12-)",
    borderRadius: "1rem",
    padding: 0,
    marginTop: 8,
    marginBottom: 0,
    height: "auto",
    minHeight: "auto",
    maxHeight: 300,
    overflow: "hidden",
    color: "var(--color-gray-)",
    fontSize: 14,
    fontFamily: "var(--font-family-regular-)",
  }),
  menuList: () => ({
    paddingTop: 0,
    paddingBottom: 0,
    height: "auto",
    minHeight: "auto",
    maxHeight: 300,
    overflow: "auto",
    "::-webkit-scrollbar": {
      width: "0px !important",
      height: "0px !important",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent !important",
    },
    "::-webkit-scrollbar-thumb": {
      background: "transparent !important",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "transparent !important",
    },
  }),
  /**
   * Estilos de las opciones desplegables
   */
  option: (provided, state) => ({
    ...provided,
    fontSize: 13,
    color: "var(--color-gray-)",
    backgroundColor: state.isSelected
      ? "var(--color-sextary-white-)"
      : "var(--color-tertiary-white-rgba-)",
    fontFamily: "var(--font-family-regular-)",
    padding: "0.5rem 0.8rem 0.5rem 0.8rem",
    borderRadius: "1rem",
    ":hover": {
      background: "var(--color-sextary-white-)",
      color: "var(--color-black-)",
    },
  }),
  /**
   * Estilos del contenedor
   */
  container: (provided, state) => ({
    ...provided,
    marginTop: 0,
    width: "100%",
    position: "relative",
    flex: "1 1 auto",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    overflow: "visible",
    color: "var(--color-gray-)",
    fontFamily: "var(--font-family-regular-)",
    paddingTop: "0rem !important",
    marginLeft: "0px",
    paddingRight: 0,
    padding: "0px 0px",
  }),
  /**
   * Estilos placeholder del input
   */
  placeholder: (provided, state) => ({
    ...provided,
    width: "100%",
    position: "absolute",
    color: "var(--color-white-)",
    lineHeight: 1.25,
    fontFamily: "var(--font-family-regular-)",
    overflow: "hidden",
    textAlign: "start",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  /**
   * Estilos texto en el input
   */
  singleValue: (styles) => ({
    ...styles,
    fontSize: 14,
    color: "var(--color-white-)",
    fontFamily: "var(--font-family-regular-)",
    padding: "3px",
    margin: "0px",
    marginTop: "2px",
    marginLeft: 0,
    marginRight: 0,
  }),
};

export default function Suport() {
  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    description: '',
    entidad: '',
    component: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const [charging, setCharging] = useState(false);



  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    // Validación de campos requeridos
    if (!formData.name.trim()) newErrors.name = 'Este campo es requerido';
    if (!formData.email.trim()) newErrors.email = 'Este campo es requerido';
    if (!formData.subject.trim()) newErrors.subject = 'Este campo es requerido';

    setErrors(newErrors);

    // Si no hay errores, enviar los datos
    if (Object.keys(newErrors).length === 0) {
      console.log('Datos del formulario:', formData);
      setCharging(true);
      let response = await sendEmail(formData).catch(error => {
        setCharging(false);
        console.log(error)
        Swal.fire({
          icon: 'error',
          text: 'No se pudo enviar la información.'
        });
       
      });
      if (response) {
        setCharging(false);
        Swal.fire({
          icon: 'success',
          text: 'Enviado con exito'
        });
        setFormData({
          name: '',
          lastName: '',
          email: '',
          phone: '',
          subject: '',
          description: '',
          entidad: '',
          component: ''
        })
      }
      // Aquí puedes enviar los datos al servidor
    }
  };


  return (
    <React.Fragment>
      {
        charging
          ?
          <Preloader></Preloader>
          :
          null
      }
      <div className="container-fluid overflow-x-hidden">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-10">
            <div className="row gx-0 gx-sm-0 gx-md-0 gx-lg-5 gx-xl-5 gx-xxl-5 d-flex flex-wrap flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row flex-xxl-row justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-between justify-content-xl-between justify-content-xxl-between align-items-center align-self-center">
              <div className="col d-flex flex-column">
                <div className="w-auto d-flex flex-row justify-content-center align-items-center align-self-start">
                  <div className="me-3 p-2 rounded-circle d-flex flex-row justify-content-center align-items-center align-self-center bg-white- wrapper-icon-rounded-">
                    <img className="icon-databases-" src={IconSuport} alt="" />
                  </div>
                  <h1 className="m-0 p-0 lh-sm fs-0- ff-monse-extrabold- tx-white-">
                    Contactanos
                  </h1>
                </div>
                <div className="w-100 mt-4">
                  <p className="m-0 p-0 lh-sm text-justify- fs-5- ff-monse-regular- fw-normal tx-bone-gray-">
                    Por favor, complete el siguiente formulario para enviarnos
                    su consulta o mensaje. Nuestro equipo revisará su solicitud
                    y se pondrá en contacto con usted a la brevedad posible.
                    Agradecemos su interés y estaremos encantados de ayudarle.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12">
            <div className="card border-0 br-1- w-100 position-relative bg-blue-translucent- glass-effect- bs-4- p-0 card-contact-">
              <div className="card-body">
                <form
                  id="internal-form-inline"
                  action=""
                  className="position-relative"

                >
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-3 mb-xxl-3">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Entidad{" "}
                        <span className="lh-sm fs-5- ff-monse-regular- fw-bold tx-red-">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ingrese el nombre de la entidad"
                        name="entidad"
                        value={formData?.entidad}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-3 mb-xxl-3">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Nombre{" "}
                        <span className="lh-sm fs-5- ff-monse-regular- fw-bold tx-red-">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        placeholder="Ingrese su nombre"
                        name="name"
                        value={formData?.name}
                        onChange={handleChange}
                      />
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-3 mb-xxl-3">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Apellido
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ingrese su apellido"
                        name="lastName"
                        value={formData?.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-3 mb-xxl-3">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Correo{" "}
                        <span className="lh-sm fs-5- ff-monse-regular- fw-bold tx-red-">
                          *
                        </span>
                      </label>
                      <input
                        type="email"
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        placeholder="Ingrese su correo"
                        name="email"
                        value={formData?.email}
                        onChange={handleChange}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-3 mb-xxl-3">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Teléfono
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Ingrese su teléfono"
                        name="phone"
                        value={formData?.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-3 mb-xxl-3">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Asunto{" "}
                        <span className="lh-sm fs-5- ff-monse-regular- fw-bold tx-red-">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.subject ? 'is-invalid' : ''}`}
                        placeholder="Ingrese su asunto"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                      {errors.subject && <div className="invalid-feedback">{errors.subject}</div>}
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-3 mb-xxl-3">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Modulo con incovenientes
                      </label>
                      <div className="form-floating inner-addon- left-addon-">
                        <input
                          type="text"
                          className={`form-control`}
                          placeholder="Ingrese el nombre componente del cual requiere soporte"
                          name="component"
                          value={formData.component}
                          onChange={handleChange}
                        />

                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <label class="form-label lh-sm fs-5- ff-monse-regular- fw-bold tx-white-">
                        Descripción
                        <span className="lh-sm fs-5- ff-monse-regular- fw-bold tx-red-"></span>
                      </label>
                      <textarea
                        className="form-control pt-2 pb-2"
                        rows="5"
                        placeholder="Ingrese una corta descripción aquí"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="row gx-2 d-flex flex-row justify-content-center align-items-start align-self-start mt-3">
                    <div className="col-12 col-sm-12 col-md-9 col-lg-8 col-xl-8 col-xxl-8">
                      <button
                        className="btn rounded-pill d-flex flex-row justify-content-center align-items-center align-self-center w-100 btn-green-light- h-40-"
                        type="button"
                        onClick={handleSubmit}
                      >
                        <span className="lh-1 fs-6- ff-monse-regular- fw-semibold">
                          Enviar
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
